import { Controller } from "@hotwired/stimulus"
import mapboxSdk from '@mapbox/mapbox-sdk'
import mapboxgl from 'mapbox-gl'
import GeocodingClient from '@mapbox/mapbox-sdk/services/geocoding'

// Connects to data-controller="mapbox"
export default class extends Controller {
  static values = { accessToken: String, address: String }
  static targets = ["map", "mapError", "marker"]

  connect() {
    mapboxgl.accessToken = this.accessTokenValue
    try {
      this.map = new mapboxgl.Map({
        container: this.mapTarget.id,
        center: [-83.7487, 42.2658],
        zoom: 9, // starting zoom
        attributionControl: false
      });
      // Report the success so we have a baseline for how often it does work.
      fetch("/api/v1/metrics/increment_counter?name=mapbox.load.success", { method: "POST" });
    } catch (error) {
      // Report the error so we know how often it happens.
      fetch("/api/v1/metrics/increment_counter?name=mapbox.load.error", { method: "POST" });

      // Show an error message.
      this.mapErrorTarget.classList.remove('hidden');
      return;
    }
    
    if (this.addressValue) {
      const geocodingClient = new GeocodingClient({ accessToken: this.accessTokenValue })
      geocodingClient.forwardGeocode({
        query: this.addressValue,
        limit: 1
      })
      .send()
      .then(response => {
        const match = response.body;
        const [lng, lat] = match.features[0].center;
        this.map.flyTo({ center: [lng, lat], zoom: 9 });
      })
    }

    if (this.markerTargets.length > 0) {
      for (const markerTarget of this.markerTargets) {
        const lng = markerTarget.dataset.mapMarkerLongitude
        const lat = markerTarget.dataset.mapMarkerLatitude

        if (lng && lat) {
          new mapboxgl.Marker()
            .setLngLat([lng, lat])
            .addTo(this.map)
        }
      }
    }
  }


}
